export default __webpack_public_path__ + "static/media/selamat8.46309f5d.svg";